import { AspectRatio, Avatar, Button, Flex, Heading, Stack, Text } from '@chakra-ui/react'
import { type CampaignEntity, toCmsMediaFileUrl } from '@twlvxtwlv/cms'
import { type Customer, toPublicMediaFileUri } from '@twlvxtwlv/tokenforge'
import { useTranslation } from 'next-i18next'
import { useRouter } from 'next/router'
import { useState } from 'react'
import { Video } from '../../../../../shared/video'
import { initDistinctId } from '@twlvxtwlv/utils/src/cookie'
import { serverSideTrackEvent } from '@twlvxtwlv/analytics/browser'

interface CampaignHeroProps {
  artist: Customer | null
  campaignEntity: CampaignEntity | null
  isAwardTeaser: boolean
  isLabelTeaser?: boolean
}

export function CampaignHero({
  artist,
  campaignEntity,
  isAwardTeaser,
  isLabelTeaser,
}: CampaignHeroProps) {
  const router = useRouter()
  const { t } = useTranslation(['nft-details', 'campaign'])
  const [ctaButtonText] = useState(
    campaignEntity?.attributes?.ctaButton?.buttonTitle ?? t('campaign:newsletter-link')
  )

  //TODO: Remove this Temp Code once we have access to CMS

  const isEmbassyOneCampaign =
    campaignEntity?.attributes?.tokenForge?.campaignId === 'Digital_Vinyl'

  const profileImageUrl = isEmbassyOneCampaign
    ? '/images/campaign/DV/dv-logo-square.png'
    : toPublicMediaFileUri(artist?.profileImage)

  const profileName = isEmbassyOneCampaign ? 'Embassy One' : artist?.profileName

  const videoUrl = toCmsMediaFileUrl(campaignEntity?.attributes?.Video?.data?.attributes?.url)

  const distinctId = initDistinctId()

  function handleCtaButtonClicked() {
    serverSideTrackEvent(
      { userId: distinctId },
      {
        eventName: 'campaign-page-cta-button-clicked',
        artistId: artist?.uuidAsString ?? 'MISSING_VALUE',
        artistName: profileName ?? 'MISSING_VALUE',
        campaignId: campaignEntity?.id ?? 'MISSING_VALUE',
        campaignSlug: (router?.query?.id as string) ?? 'MISSING_VALUE',
        buttonText: ctaButtonText ?? 'MISSING_VALUE',
      }
    )
    router.push('#newsletter')
  }

  return (
    <Stack spacing={0} gap={[4, 4, 4, 4, 6]}>
      <Flex alignItems="center" gap={4}>
        <Avatar
          alignItems="end"
          size={['md', 'md', 'md', 'md', 'lg']}
          name={profileName ?? ''}
          src={profileImageUrl}
        />
        <Stack align="start">
          <Text
            fontWeight="400"
            color="white"
            fontSize={['xl', 'xl', 'xl', 'xl', '2xl']}
            textTransform="uppercase"
          >
            {profileName ?? ''}
          </Text>
          <Heading fontSize={['xs', 'xs', 'md']} fontWeight="400" color="txtLightGray">
            {isAwardTeaser
              ? t('award')
              : isLabelTeaser
              ? t('nft-details:label-name')
              : t('nft-details:artist-name')}
          </Heading>
        </Stack>
      </Flex>
      {videoUrl ? (
        <Flex w="full" justify="center">
          <AspectRatio w="full" maxW="400px" ratio={16 / 9}>
            <Video url={videoUrl} autoStart={true} />
          </AspectRatio>
        </Flex>
      ) : null}
      {campaignEntity?.attributes?.ctaButton?.enable ? (
        <Flex w="full" justify="center" pt={6} pb={4}>
          <Button
            onClick={handleCtaButtonClicked}
            w={['95%', '90%', '75%', '50%', '65%', '65%']}
            h="42px"
            variant="txtSignalLime"
          >
            {ctaButtonText}
          </Button>
        </Flex>
      ) : null}
    </Stack>
  )
}
